<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="teacherSummary && teacherProgress">
			<title-bar title="Progreso" :percentage="teacherSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="teacherSummary.itemName" :percentage="teacherSummary.itemPercentage" percentageTitle="Promedio Docente" :academicLevelTitle="teacher.academicLevelName"/>
			<div class="col full">
				<div class="row between innerRubric">
					<progress-chart v-for="category in progressionReport.coachingCategories" :key="category.id" :categoryId="category.id" :data="category.graphData" :title="category.name" :percentage="category.percentage"/>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['teacherPersonUuid'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		teacherSummary () {
			if (this.$store.state.teachers.summary) return this.$store.state.teachers.summary.find((item) => {
				return item.itemId == this.teacherPersonUuid;
			});
			return this.$store.state.teachers.summary;
		},
		teacherProgress () {
			if (this.$store.state.teachers.progress) return this.$store.state.teachers.progress.find((item) => {
				return item.teacher.teacherPersonUuid == this.teacherPersonUuid;
			}).progress;
			return this.$store.state.teachers.progress;
		},
		teacher () {
			if (this.$store.state.teachers.progress) return this.$store.state.teachers.progress.find((item) => {
				return item.teacher.teacherPersonUuid == this.teacherPersonUuid;
			}).teacher;
			else return this.$store.state.teachers.progress;
		},
		progressionReport () {
			if (!this.teacherSummary) return [];
			this.teacherSummary.coachingCategories.forEach((coachingCategory) => {
				coachingCategory.graphData = {
					labels: this.teacherProgress.map((visit) => {
						let result = null;
						visit.coachingCategories.forEach((category) => {
							if (category.id == coachingCategory.id) result = parseInt(category.percentage);
						});
						if (result) return `Visita ${visit.number}: ${result}%`;
						else return `Visita ${visit.number}`;
					}),
					datasets:	[{
						data: this.teacherProgress.map((visit) => {
							let result = null;
							visit.coachingCategories.forEach((category) => {
								if (category.id == coachingCategory.id) result = parseInt(category.percentage);
							});
							return result;
						}),
						borderWidth: 2,
						dates: this.teacherProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				};
				return coachingCategory;
			});
			return this.teacherSummary;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/teachers/CategoriesProgress.vue